import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';

const { clientTopology } = renderModel.get();

export const getVoteStatus = async (id: string): Promise<boolean> => {
  try {
    const url = `${clientTopology.articlesUrl}/${id}/vote`;
    const response = await httpClient.getInstance().get(url);

    return response.data.articleVoteStatus;
  } catch (error) {
    logger.error({
      message: `[voteArticle] Failed to get vote status for the article: ${id}`,
      error,
    });
    console.error(error);
  }

  return false;
};

export const vote = async (id: string): Promise<void> => {
  try {
    const url = `${clientTopology.articlesUrl}/${id}/vote`;
    await httpClient.getInstance().post(url);
  } catch (error) {
    logger.error({
      message: `[voteArticle] Failed to vote for the article: ${id}`,
      error,
    });
    console.error(error);
  }
};

export const unvote = async (id: string): Promise<void> => {
  try {
    const url = `${clientTopology.articlesUrl}/${id}/vote`;
    await httpClient.getInstance().delete(url);
  } catch (error) {
    logger.error({
      message: `[voteArticle] Failed to vote for the article: ${id}`,
      error,
    });
    console.error(error);
  }
};
